import { toast } from "react-toastify";
import { getMethod, postMethod, setAuthorizationToken } from "../../api-service/api-service";
import { setLoading, setUser } from "./authSlice";
import Cookies from "js-cookie";

export const loginAction = (data) => async (dispatch) => {
    try {
        dispatch(setLoading(true))
        const response = await postMethod("/auth/admin/login", data);
        if (response.success === true) {
            dispatch(setUser(response?.user));
            setAuthorizationToken(response?.token);
            const token = response?.token;
            Cookies.set("jwt", token, { expires: 7 });
            toast.success("Login Successfull");
        } else {
            toast.error(response?.message || "Login Failed");
        }
        dispatch(setLoading(false));
        return response;
    } catch (error) {
        const message =
            error?.response?.data?.message || "Unable to login at the moment";

        toast.error(message);
        return { success: false, message: error?.response?.data?.message }
    }
};

export const fetchUserAction = () => async (dispatch) => {
    try {
        const response = await getMethod('/auth/fetch-admin');
        if (response.success === true) {
            dispatch(setUser(response?.user));
        }
        return response;
    } catch (error) {
        console.log("Error: ", error);
        return { success: false, message: error };
    }
}

export const logoutAction = () => async (dispatch) => {
    try {
        dispatch(setUser(null));
        Cookies.remove('jwt');
        toast.success("Logged Out")
        return { success: true }
    } catch (error) {
        console.log("Error: ", error);
        toast.error('Unable to Log out')
        return { success: false, message: error };
    }
}